import { Component, OnInit } from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import { HttpService } from 'src/app/services/http.service';
import {environment} from '../../../../environments/environment';
import {MatDialogRef} from '@angular/material/dialog';
import {HistoryDialogComponent} from '../../dialogs/history-dialog/history-dialog.component';

@Component({
  selector: 'app-cell-history-restore-button',
  templateUrl: './cell-history-restore-button.component.html',
  styleUrls: ['./cell-history-restore-button.component.scss']
})
export class CellHistoryRestoreButtonComponent implements ICellEditorAngularComp, OnInit {
  private params: any;
  constructor(
    private httpService: HttpService,
    private dialogRef: MatDialogRef<HistoryDialogComponent>,
  ) { }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
    // console.log('params:', params);
    // this.selected = params.value;
    // console.log('CellEditorBrandComponent agInit', params);
  }

  getValue(): any {
    console.log('-----this.params', this.params);
    return true;
  }

  public restore(): void {
    console.log('-----this.params', this.params);
    console.log('this', this);
    this.httpService.post(environment.API_PATH + '/product/field/changes/restore', {
      _id: this.params.data._id,
      product_id: this.params.data.product_id,
      field: this.params.data.field
    }).subscribe(resp => {
        this.dialogRef.close();
        console.log('restore', resp);
      });
  }
}
